export default "__VITE_ASSET__ElxmF4so__"